import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Service.css"; // Import your custom CSS
import web from "./../images/web-development.png";
import mob from "./../images/mobile-development.png";
import dm from "./../images/social-media-marketing.png";
import seo from "./../images/seo.png";
import gd from "./../images/graphics-design.png";
import { motion, AnimatePresence } from "framer-motion";
import "hover.css/css/hover-min.css";
import Media from "./Media";

function Service() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    axios
      .get("https://back.waratechnology.com/api/service/getservice")
      .then((res) => {
        setServices(res.data.data);
        console.log(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <AnimatePresence mode="wait">
      <motion.div
        initial={{ y: 10, opacity: 1 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -10, opacity: 1 }}
        transition={{ duration: 0.2 }}
        id="services"
        className="services_area pt-120 pb-120 ser"
      >
        <div className="container pt-28">
          <div className="row justify-center">
            <div className="w-full lg:w-1/2">
              <div className="section_title text-center pb-4">
                <h5 className="text-gray-500">What We Do</h5>
                <h4 className="main_title text-4xl md:text-6xl font-bold font-play">
                  Our Services
                </h4>
              </div>
            </div>
          </div>
          <div className="row justify-center mb-6">
            {services.map((data, index) => (
              <div
                className="w-full sm:w-10/12 md:w-6/12 lg:w-4/12"
                key={index}
              >
                <div
                  className="single_services text-center mt-2 mx-3 shadow-lg hvr-sweep-to-bottom"
                  style={{
                    "--hover-bg-color":
                      "linear-gradient(to right, #f56565, #ed8936, #ecc94b)",
                  }} // Optional: Dynamic color
                >
                  <div className="services_icon">
                    <svg
                      xmlns={data.image}
                      width="94"
                      height="92"
                      viewBox="0 0 94 92"
                    >
                      <defs>
                        <linearGradient
                          id="gradient"
                          x1="0%"
                          y1="0%"
                          x2="100%"
                          y2="0%"
                        >
                          <stop
                            offset="0%"
                            style={{ stopColor: "#f56565", stopOpacity: 1 }}
                          />
                          <stop
                            offset="50%"
                            style={{ stopColor: "#ed8936", stopOpacity: 1 }}
                          />
                          <stop
                            offset="100%"
                            style={{ stopColor: "#ecc94b", stopOpacity: 1 }}
                          />
                        </linearGradient>
                      </defs>

                      <path
                        className="services_shape"
                        id="Polygon_12"
                        data-name="Polygon 12"
                        d="M42.212,2.315a11,11,0,0,1,9.576,0l28.138,13.6a11,11,0,0,1,5.938,7.465L92.83,54.018A11,11,0,0,1,90.717,63.3L71.22,87.842A11,11,0,0,1,62.607,92H31.393a11,11,0,0,1-8.613-4.158L3.283,63.3A11,11,0,0,1,1.17,54.018L8.136,23.383a11,11,0,0,1,5.938-7.465Z"
                        fill="url(#gradient)"
                      />
                    </svg>

                    <img
                      src={`https://back.waratechnology.com${data.image}`}
                      alt=""
                      className="w-12 h-12 z-1 -mt-16 ml-6 font-bold"
                    />
                  </div>
                  <div className="services_content mt-5 xl:mt-10">
                    <h3 className="services_title text-black font-semibold text-xl md:text-2xl lg:text-xl xl:text-3xl hover:text-whitesmoke font-play">
                      {data.name}
                    </h3>
                    <p className="mt-4 text-[#575656] font-normal font-sans text-base md:text-lg lg:text-xl">
                      {data.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* <Media /> */}
      </motion.div>
    </AnimatePresence>
  );
}

export default Service;
